//--computer styles ideas:
//sneaky pete: never pull from discard pile
//mal melon: hold on to card it know the oppoenent needs
//lucky 7: alway draw and hold on to 7s
//impossible: track oppnenets cards and guess he has matches to them 
//todo: track actions from activity log and use that to make decisions
export const AIRuleSets = {
    "Human": {
        "preGame": [],
        "deal": [],
        "firstCard": [],
        "mustTakeTop": [],
        "draw": [],
        "discard": [],
        "knock": [],
        "layoff": [],
        "undercut": [],
        "scoring": [],
        "gameOver": [],
    },
    "Easy": {
        "preGame": [],
        "deal": [],
        "firstCard": [
            "TakeDiscardIfStartsRunInDeadwood",
            "Pass"
        ],
        "mustTakeTop": [
            "TakeTopDraw"
        ],
        "draw": [
            "TakeDiscardIfStartsRunInDeadwood",
            "TakeTopDraw",
            "TakeDiscardOrTakeTopRandom"
        ],
        "discard": [
            "KnockIfCan",
            "DiscardHighestDeadwoodWhichIsNotARunOf2",
            "DiscardHighestDeadwood",
            "DiscardARandomCard"
        ],
        "knock": [],
        "layoff": [],
        "undercut": [],
        "scoring": [],
        "gameOver": [],
    },
    "Medium": {
        "preGame": [],
        "deal": [],
        "firstCard": [
            "TakeDiscardIfMakesPairInDeadwood",
            "Pass"
        ],
        "mustTakeTop": [
            "TakeTopDraw"
        ],
        "draw": [
            "TakeDiscardIf5",
            "TakeDiscardIfMakesPairInDeadwood",
            "TakeTopDraw",
            "TakeDiscardOrTakeTopRandom"
        ],
        "discard": [
            "KnockIfCan",
            "DiscardHighestDeadwoodWhichIsNotAPair",
            "DiscardHighestDeadwood",
            "DiscardARandomCard"
        ],
        "knock": [],
        "layoff": [],
        "undercut": [],
        "scoring": [],
        "gameOver": [],
    },
    "Hard": {
        "preGame": [],
        "deal": [],
        "firstCard": [
            "TakeDiscardIfLowerDeadwoodCardCount",
            "TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile",
            "Pass"
        ],
        "mustTakeTop": [
            "TakeTopDraw"
        ],
        "draw": [
            "TakeDiscardIfLowerDeadwoodCardCount",
            "TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile",
            "TakeTopDraw"
        ],
        "discard": [
            "KnockAnyDeadwoodIfEarlyGame",
            "KnockBelow8DeadwoodIfMidGame",
            "KnockBelow5DeadwoodIfLateGame",
            "KnockIfGin",
            "DiscardHighestDeadwoodWhichTwoOfSameRankForPairAreHiddenInDiscardPile",
            "DiscardHighestDeadwoodWhichTwoOnBothSidesForRunAreHiddenInDiscardPile",
            "DiscardHighestDeadwoodIfLessThan4CardsLeftInDeadWood",
            "DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2AndHasAMatchingRankInTheDiscardPile",
            "DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2",
            "DiscardLowestPairEarlyInTheGame",
            "DiscardHighestPair",
            "DiscardHighestDeadwood",
            "DiscardARandomCard"
        ],
        "knock": [],
        "layoff": [],
        "undercut": [],
        "scoring": [],
        "gameOver": [],
    },
    "CrazyNinja": {
        "preGame": [],
        "deal": [],
        "firstCard": [
            "TakeDiscardIfLowerDeadwoodCardCount",
            "TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile",
            "Pass"
        ],
        "mustTakeTop": [
            "TakeTopDraw"
        ],
        "draw": [
            "TakeDiscardIfLowerDeadwoodCardCount",
            "TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile",
            "TakeTopDraw"
        ],
        "discard": [
            "KnockAnyDeadwoodIfEarlyGame",
            "KnockBelow8DeadwoodIfMidGame",
            "KnockBelow5DeadwoodIfLateGame",
            "KnockIfGin",
            "DiscardHighestDeadwoodWhichTwoOfSameRankForPairAreHiddenInDiscardPile",
            "DiscardHighestDeadwoodWhichTwoOnBothSidesForRunAreHiddenInDiscardPile",
            "DiscardHighestDeadwoodIfLessThan4CardsLeftInDeadWood",
            "DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2AndHasAMatchingRankInTheDiscardPile",
            "DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2",
            "DiscardLowestPairEarlyInTheGame",
            "DiscardHighestPair",
            "DiscardHighestDeadwood",
            "DiscardARandomCard"
        ],
        "knock": [],
        "layoff": [],
        "undercut": [],
        "scoring": [],
        "gameOver": [],
    },
    "Test": {
        "preGame": [],
        "deal": [],
        "firstCard": [
            "TakeDiscardIfLowerDeadwoodCardCount",
            "TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile",
            "Pass"
        ],
        "mustTakeTop": [
            "TakeTopDraw"
        ],
        "draw": [
            "TakeDiscardIfLowerDeadwoodCardCount",
            "TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile",
            "TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile",
            "TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile",
            "TakeTopDraw"
        ],
        "discard": [
            "KnockAnyDeadwoodIfEarlyGame",
            "KnockBelow8DeadwoodIfMidGame",
            "KnockBelow5DeadwoodIfLateGame",
            "KnockIfGin",
            "DiscardHighestDeadwoodWhichTwoOfSameRankForPairAreHiddenInDiscardPile",
            "DiscardHighestDeadwoodWhichTwoOnBothSidesForRunAreHiddenInDiscardPile",
            "DiscardHighestDeadwoodIfLessThan4CardsLeftInDeadWood",
            "DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2AndHasAMatchingRankInTheDiscardPile",
            "DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2",
            "DiscardLowestPairEarlyInTheGame",
            "DiscardHighestPair",
            "DiscardHighestDeadwood",
            "DiscardARandomCard"
        ],
        "knock": ["NextAction"],
        "layoff": ["NextAction"],
        "undercut": ["NextAction"],
        "scoring": ["NextAction"],
        "gameOver": ["NextAction"],
    },
};
//# sourceMappingURL=data:application/json;base64,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